import React, { ReactNode } from "react"
import create from "zustand"

interface State {
  isShowingCookiePopup: boolean
  setIsShowingCookiePopup: (val: boolean) => void
  popupMsg: ReactNode | null
  setPopupMsg: (val: ReactNode | null) => void
}

const useStore = create<State>(set => ({
  isShowingCookiePopup: false,
  setIsShowingCookiePopup: val => set(state => ({ isShowingCookiePopup: val })),
  popupMsg: null,
  setPopupMsg: val => set(state => ({ popupMsg: val })),
}))

export default useStore
